<svelte:options tag={null} />

<script lang="ts">
  import type { ProgressBarSize } from './progressbar.types';

  export let value: number;
  export let valuemin = 0;
  export let valuemax = 100;
  export let displaypercentage: boolean;
  export let size: ProgressBarSize = 'm';
  export let branded: boolean;

  function getClasses(displaypercentage: boolean): string {
    const classes = ['mc-progressbar'];

    if (displaypercentage) {
      classes.push('mc-progressbar--percent');
    }

    if (value >= 51) {
      classes.push('mc-progressbar--half');
    }

    if (size === 's') {
      classes.push('mc-progressbar--s');
    } else if (size === 'xs') {
      classes.push('mc-progressbar--xs');
    }

    if (branded) {
      classes.push('mc-progressbar--branded');
    }

    return classes.join(' ');
  }
</script>

<div class="{getClasses(displaypercentage)} {$$props.class}" {...$$restProps}>
  <div
    class="mc-progressbar__indicator"
    role="progressbar"
    aria-valuenow={value}
    aria-valuemin={valuemin}
    aria-valuemax={valuemax}
    style="width: {value}%;"
  >
    &nbsp;
  </div>
  {#if displaypercentage}
    <div class="mc-progressbar__percentage">{value}%</div>
  {/if}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.progressbar';
</style>
